import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x7301,
  properties: ["read", "write", "notify"],
};

export function generateMockIVSENofifyData(): DomianControl.IVSENotifyData {
  const data = getMockDataByKeys(
    [
      "UIRx_ACULatAcc",
      "UIRx_ACULongdAcc",
      "UIRx_VehMass",
      "UIRx_FLVertDynF",
      "UIRx_FRVertDynF",
      "UIRx_RLVertDynF",
      "UIRx_RRVertDynF",
      "UIRx_FxyFL",
      "UIRx_FxyFR",
      "UIRx_FxyRL",
      "UIRx_FxyRR",
      "UIRx_ThetaFxyFA",
      "UIRx_ThetaFxyRA",
      "UIRx_BetaObs",
      "UIRx_mueFL",
      "UIRx_mueFR",
      "UIRx_mueRL",
      "UIRx_mueRR",
      "UIRx_AxleStAng_RA",
      "UIRx_AxleStAng_FA",
      "UIRx_DUIdx_FL",
      "UIRx_DUIdx_FR",
      "UIRx_DUIdx_RR",
      "UIRx_DUIdx_RL",
    ]
    // {
    //   UIRx_ACULatAcc:[-1, 1],
    //   UIRx_ACULongdAcc:[-1, 1],
    //   UIRx_ACUYawRate:[-75, 75],
    //   UIRx_DeltaOff_FA:[-5, 5],
    //   UIRx_SBW_HWAAng:[-500, 500],
    //   UIRx_DeltaOff_RA:[-5, 5],
    //   UIRx_alphaRA:[-5, 5],
    //   UIRx_WhlBrkTqAct_FL_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_FR_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_RL_BCh1:[0, 2000],
    //   UIRx_WhlBrkTqAct_RR_BCh1:[0, 2000],
    // }
  );
  return data;
}
